import React, { useEffect, useState } from "react";
import { fetchSoundData } from './Data/parseSheetData';
import styles from "./Footer.module.css";
import fbblack from "./facebook-f-brandsblack.png";
import Inblack from "./instagram-brandsblack.png";
import twblack from "./x-twitter-brandsblack.png";
import shblack from "./share-from-square-regularblack.png";

const url = encodeURIComponent(window.location.href);
const shareToFacebook = () => {
  window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, "_blank");
};

const shareToInstagram = () => {
  window.open(`https://www.instagram.com/p/DOfpI8ejRns/?img_index=1`, "_blank");
};

const shareToTwitter = () => {
  const text = encodeURIComponent(document.title);
  window.open(
    `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
    "_blank"
  );
};

const shareLink = async () => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: document.title,
        text: "Check this out!",
        url: window.location.href,
      });
      //console.log("Link shared successfully");
    } catch (err) {
      console.error("Error sharing:", err);
    }
  } else {
    alert(
      "Sharing not supported on this browser. Please copy the link manually."
    );
  }
};

export const Footer = () => {
  React.useEffect(() => {
    const handleResize = () => {
      const researcherDiv = document.querySelector(".researcher-inline");
      if (researcherDiv) {
        if (window.innerWidth <= 768) {
          researcherDiv.style.display = "grid";
          researcherDiv.style.gridTemplateColumns = "repeat(2, auto)";
          researcherDiv.style.rowGap = "6px";
          researcherDiv.style.columnGap = "12px";
        } else {
          researcherDiv.style.display = "flex";
          researcherDiv.style.flexWrap = "nowrap";
        }
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [sheetData, setSheetData] = useState([]);

  // useEffect(() => {
  //   fetch("https://opensheet.vercel.app/1RY--tShylE4tNaO-jr1utv9uaTHSXabK-UXqr3eORV4/Sheet1")
  //     .then((res) => res.json())
  //     .then((data) => setSheetData(data))
  //     .catch((err) => console.error("Failed to fetch sheet data:", err));
  // }, []);

  useEffect(() => {
    const loadSheetData = async () => {
      try {
        const rows = await fetchSoundData();
        setSheetData(rows);
      } catch (err) {
        console.error("Failed to load sound data:", err);
      }
    };

    loadSheetData();
  }, []);

  const footerData = sheetData?.[0] || {};

  const roles = Array.from(
    { length: Number(footerData.Total_Role) || 0 },
    (_, index) => ({
      role: footerData[`Role_${index + 1}`],
      value: footerData[`Role_value_${index + 1}`],
    })
  );

  const parseMarkdownLinks = (text) => {
    if (!text) return "";

    return text.replace(
      /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
      `<a href="$2" target="_blank" rel="noopener noreferrer" class="${styles.dynamicLink}">$1</a>`
    );
  };
  // console.log("Roles", roles);

  const group1 = roles.slice(0, 1);
  const group2 = roles.slice(1, 4);
  const group3 = roles.slice(4, 10);
  const group4 = roles.slice(10, 12);
  const group5 = roles.slice(12, 13);

  const renderCreditCard = (item, index, isFullWidth = false) => {
    const names = (item.value
      ?.split("|")
      .map((entry) => {
        const [name, link] = entry.split("::");
        return {
          name: name?.trim(),
          link: link?.trim(),
        };
      })
      .filter((n) => n.name)) ?? [];

    return (
      <div key={index} className={`${styles.creditCard} ${isFullWidth ? styles.fullWidth : ""}`}>
        <span className={styles.role}>
          {item.role}
        </span>

        <div className={styles.namesWrapper}>
          {names.map((person, idx) => (
            <React.Fragment key={idx}>
              {person.link ? (
                <a
                  href={person.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.nameLink}
                >
                  {person.name}
                </a>
              ) : (
                <span className={styles.name}>
                  {person.name}
                </span>
              )}

              {idx !== names.length - 1 && (
                <span className={styles.separator}>
                  |
                </span>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.footerContainer}>
      <div className={styles.section}>
        <span className={styles.title}>Production Credits</span>

        <div className={styles.group}>
          {/* Group 1: Role 1 only */}
          <div className={styles.groupGrid}>
            {group1.map((item, idx) => renderCreditCard(item, idx, true))}
          </div>

          {/* Group 2: Roles 2-4 */}
          <div className={styles.groupGrid}>
            {group2.map((item, idx) => renderCreditCard(item, idx + 1))}
          </div>

          {/* Group 3: Roles 5-10 */}
          <div className={styles.groupGrid}>
            {group3.map((item, idx) => renderCreditCard(item, idx + 4))}
          </div>

          {/* Group 4 & 5 Wrapper with 1rem gap */}
          <div className={styles.groupSubWrapper}>
            {/* Group 4: Role 11+ */}
            <div className={styles.groupGrid}>
              {group4.map((item, idx) => renderCreditCard(item, idx + 10))}
            </div>

            <div className={styles.groupGrid}>
              {group5.map((item, idx) => renderCreditCard(item, idx + 12, true))}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.support}>
        <span className={styles.title}>
          Project Supported by:
        </span>

        <p
          className={styles.description}
          style={{ maxWidth: "725px" }}
          dangerouslySetInnerHTML={{
            __html: parseMarkdownLinks(
              footerData?.Para_7
            ),
          }}
        />
        <br />
        <p
          className={styles.description}
          style={{ maxWidth: "725px" }}
          dangerouslySetInnerHTML={{
            __html: parseMarkdownLinks(
              footerData?.Para_8
            ),
          }}
        />
      </div>

      <br />
      <br />
      <center>
        <div className={styles.section}>
          <div className={styles.imageContainer}>
            <button
              onClick={shareToFacebook}
              style={{
                marginRight: "10px",
                background: "none",
                border: "none",
                padding: 0,
              }}
            >
              <img
                src={fbblack}
                alt="Facebook"
                className={styles.supporterImageFB}
              />
            </button>
            <button
              onClick={shareToInstagram}
              style={{
                marginRight: "10px",
                background: "none",
                border: "none",
                padding: 0,
              }}
            >
              <img
                src={Inblack}
                alt="Instagram"
                className={styles.supporterImageIG}
              />
            </button>
            <button
              onClick={shareToTwitter}
              style={{
                marginRight: "10px",
                background: "none",
                border: "none",
                padding: 0,
              }}
            >
              <img
                src={twblack}
                alt="Twitter"
                className={styles.supporterImageX}
              />
            </button>
            <button
              onClick={shareLink}
              style={{ background: "none", border: "none", padding: 0 }}
            >
              <img
                src={shblack}
                alt="Share Link"
                className={styles.supporterImageSH}
              />
            </button>
          </div>
          <p className={styles.name1}>
            <span className={styles.copyrightSymbol}>
              &copy;
            </span>
            <span>
              NANDITA KUMAR
            </span>{" "}
            <span className={styles.year}>
              2025
            </span>
          </p>
        </div>
      </center>
    </div>
  );
};
